  <form name="commentsForm" novalidate [formGroup]="commentsForm" id="comments-form" (ngSubmit)="onCommentsSave()" #commentForm="ngForm">
      <div class="modal fade" bsModal tabindex="-1" role="dialog" aria-labelledby="Comments" aria-hidden="true" #commentsModal="bs-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                
                 <div class="modal-header bg-primary text-white">
                    <p class="modal-title h3"><strong>{{title}}</strong></p>
                    <button type="button" class="btn btn-sm btn-primary" aria-label="Close" (click)="closeModal()">
                      <span aria-hidden="true"><i class="fa fa-close"></i></span>
                    </button>
                </div>
                <div class="modal-body modal-border">
                        <small class="text-muted">
                             {{headerText}}
                        </small>
                        <div class="form-group comment-form" [ngClass]="{ 'has-error': !commentsForm.controls['commentsContent'].valid && commentsForm.controls['commentsContent'].touched }">
                            <textarea class="form-control" formControlName="commentsContent"></textarea>
                            <div *ngIf="commentsForm.controls['commentsContent'].hasError('required') && commentsForm.controls['commentsContent'].touched" class="alert alert-danger">Comments are required.</div>
                        </div>
                    </div>
                    <div class="modal-footer bg-faded text-muted">
                        <button type="submit" class="btn btn-primary ml-2 btn-sm" form="comments-form" [disabled]="!commentsForm.controls['commentsContent'].valid">
                                {{submitButtonText}}</button>
                    </div>
                </div>
            </div>
        </div>
 </form>